import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_S3_download extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_s3_download">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.S3.download</h2>
              <p>
                NL.S3.download a single file or key from an AWS bucket.
              </p>
              <p style={{ color: "#D32F2F", fontWeight: "bold" }}>You require a seperate AWS account with appropriate permissions.</p>
              <WorkflowCompatibility front={false} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">S3Bucket</td>
                    <td>
                      Name of the AWS S3 bucket.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">S3Key</td>
                    <td>
                      Key or filename in the S3 bucket.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">toString</td>
                    <td>
                      Download file as string.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">toObject</td>
                    <td>
                      Download JSON file as object.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.S3.download Example</h2>
              <p>This example downloads a file from an S3 Bucket as object.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">init_options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">accessKeyId</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">AKLMEDKENISJQOUT...</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">secretAccessKey</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF...</span>
                  <span className="jsonA">"</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>

                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3Bucket</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">MyTestBucket</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3Key</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">my_folder/my_file.json</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">toObject</span>
                  <span className="jsonA">: </span>
                  <span className="jsonP">true</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">S3</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">init</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">init_options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>
                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed to init</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">S3</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">download</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>
                <div className="i3">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i3">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i3">
                  <span className="jsonY">&#125;</span>
                </div>

                <div className="i2">
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>
                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_S3_download;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_S3_download.js